//libraries
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEye, faCheck} from '@fortawesome/free-solid-svg-icons';

//components
import { CaptchaBox } from '../components/CaptchaBox';
import { MsgBox } from '../components/MsgBox';
import { Prompt } from '../components/Prompt';

//css
import '../styles/loggedOutPages.css';

//js
import {getDevId} from '../assets/sec/getDevId';
import {usernameRules, emailRules, passwordRules} from '../assets/userCredentialRules';

//common
import {checkUsernameValidity, checkEmailValidity, checkPwdValidity} from '../common/checkInputValidity';
import { lightBlueThemeColor } from '../assets/colors-setup';


export function ResetPwd({setUser})
{
      const [isPwdVisible, setIsPwdVisible]=useState(false);
      const [isMiniMsgVisible, setIsMiniMsgVisible]=useState(false);
      const [isCaptchaVisible, setIsCaptchaVisible]=useState(false);
      const [isPromptVisible, setIsPromptVisible]=useState(false);
      const [isMsgBoxVisible, setIsMsgBoxVisible]=useState(false);
      
      const [msgBoxMsg, setMsgBoxMsg]=useState('');
      const [promptMsg, setPromptMsg]=useState('');

      const [miniMsg, setMiniMsg]=useState('');
      const [fadeIn, setFadeIn]=useState(false);

      const [email, setEmail]=useState('');
      const [password, setPassword]=useState('');
      const [regCode, setRegCode]=useState('');
      const [captchaToken, setCaptchaToken]=useState('');

      const [isEmailValid, setIsEmailValid]=useState(false);
      const [isPwdValid, setIsPwdValid]=useState(false);

      const navigate=useNavigate();

      
      useEffect(()=>
      {
            //changing background color
            document.querySelector('body').style.backgroundColor='white';
            return ()=> document.querySelector('body').style.backgroundColor=lightBlueThemeColor;
      },
      []);

      useEffect
      (
            ()=>
            {
                  setIsEmailValid( checkEmailValidity(email) );
                  setIsPwdValid( checkPwdValidity(password) );
            },
            [email, password]
      );

      function showMiniMsg(msg)
      {
            setFadeIn(true);

            setIsMiniMsgVisible(true);
            setMiniMsg(msg);

            setTimeout(() => {
                  setFadeIn(false);
            }, 1000);
      };

      async function directLogin()
      {
            let res=await axios.post('/getUser', {});
            setUser(res.data.user);

            navigate('/');
      };

      function showMsg(msg)
      {
            setMsgBoxMsg(msg);
            setIsMsgBoxVisible(true);
      };

      function showPrompt(msg)
      {
            setPromptMsg(msg);
            setIsPromptVisible(true);
      };

      async function handleResetPwd()
      {
            showMiniMsg("<b>Loading message. Please wait...</b>");
            if(navigator.onLine===false) return showMiniMsg('<b>You are offline</b>');

            let res=await axios.post('/resetPwd',
            {
                  email: email,
                  password: password,
                  captchaToken: captchaToken,
                  regCode: regCode,
                  devId: await getDevId()
            });


            showMiniMsg('');
            setIsPromptVisible(false);
            setIsCaptchaVisible(false);

            if(res.data.showMsgIn==='miniMsg') showMiniMsg(res.data.msg);

            if(res.data.showMsgIn==='prompt') showPrompt(res.data.msg);

            if(res.data.showMsgIn==='captcha') setIsCaptchaVisible(true);
            
            if(res.data.willLogin===true) showMsg('<b>Password reset successfully.</b><br>Logging in.');
      };


      return<>
            <div className="container-fluid">

                  <div className="outerFormBox row justify-content-center my-sm-5">
                        <div style={{width: '400px'}} className="px-1">

                              { isCaptchaVisible && <CaptchaBox setIsCaptchaVisible={setIsCaptchaVisible} handleDone={handleResetPwd} setCaptchaToken={setCaptchaToken} /> }

                              { isPromptVisible && <Prompt setIsPromptVisible={setIsPromptVisible} handleDone={handleResetPwd} promptMsg={promptMsg} mySetPromptInput={setRegCode} /> }

                              { isMsgBoxVisible && <MsgBox setIsMsgBoxVisible={setIsMsgBoxVisible} handleDone={directLogin} msgBoxMsg={msgBoxMsg} /> }
                              

                              <div style={ (isCaptchaVisible || isPromptVisible || isMsgBoxVisible) ? {opacity: '0.1', pointerEvents: 'none'} : {} }>

                                    <h1 className="text-center mt-3">Reset Password</h1>

                                    <div className={"px-3 py-1 mt-3 alert alert-primary "+ (fadeIn ? " animate__animated animate__fadeIn " : ' ') + (isMiniMsgVisible ? ' ' : ' invisible ') } dangerouslySetInnerHTML={{ __html: miniMsg}}></div>


                                    <div className={miniMsg!=='' ? 'moveFormBox' : ''}>
                                          <form onSubmit={ (e) => e.preventDefault() } className="rounded py-3 px-2" style={{border: '2px solid rgba(128, 128, 128, 0.715)'}}>

                                                <div className="input-group mb-3">
                                                      <input onFocus={()=>showMiniMsg(emailRules)} onBlur={()=>setIsMiniMsgVisible(false)} onChange={ (e) => setEmail(e.target.value) } className="form-control rounded" type="email" name="savedInputEmail" placeholder="Email Address" />
                                                      <div className="input-group-append">
                                                            <div className="d-flex align-items-center pl-1" style={{fontSize: '20px'}}>
                                                                  <div className={"text-success" + (isEmailValid ? '' : ' invisible')}>
                                                                        <FontAwesomeIcon icon={faCheck} /> 
                                                                  </div>
                                                            </div>
                                                      </div>
                                                </div>
                                                
                                                <div className="input-group mb-3">
                                                      <input onFocus={()=>showMiniMsg(passwordRules)} onBlur={()=>setIsMiniMsgVisible(false)} onChange={ (e) => setPassword(e.target.value) } name="savedInputPwd" type={isPwdVisible ? 'text' : 'password'} className="form-control" placeholder="New Password" />
                                                      <div className="input-group-append">
                                                            <div onClick={ (e) => {if(isPwdVisible) setIsPwdVisible(false); else setIsPwdVisible(true); } } className="rounded-right d-flex align-items-center px-1" style={{fontSize: '20px', border: '1px solid #d0cdcd', backgroundColor: isPwdVisible && 'black', color: isPwdVisible && 'white'}}>
                                                                  <FontAwesomeIcon icon={faEye} />
                                                            </div>
                                                            <div className="d-flex align-items-center pl-1" style={{fontSize: '20px'}}>
                                                                  <div className={"text-success" + (isPwdValid ? '' : ' invisible')}>
                                                                        <FontAwesomeIcon icon={faCheck} />
                                                                  </div>
                                                            </div>
                                                      </div>
                                                </div>

                                                <button onClick={handleResetPwd} type="submit" className="btn btn-block btn-primary mt-4"><b>Reset Password</b></button>

                                          </form>

                                          <Link to='/login' className='text-dark mt-4 d-inline-block'>Click here to <b><u>Login</u></b></Link>                                    
                                    </div>

                              </div>
                        
                        </div>
                  </div>

            </div>
      </>
};
